import { Injectable } from '@angular/core';
import { BookingsService } from './bookings.service';
import { ToastService } from './toast.service';
import { ApiError } from '../models/common/api-error';

@Injectable({
  providedIn: 'root'
})
export class UnlockDoorService {
  constructor(
    private bookingsService: BookingsService,
    private toastService: ToastService,
  ) {}

  async unlockDoor(token: string): Promise<boolean> {
    try {
      await this.bookingsService.unlockDoor(token);
      this.toastService.success(
        "La porte va s'ouvrir dans quelques instants.",
        'Ouverture en cours',
        7500,
      );
      return true;
    } catch (exception) {
      this.toastService.error((exception as ApiError).message);
      console.error(exception);
      return false;
    }
  }
}